
<div class="n-tour-step-host" :class="{ 'is-inline': inline, 'is-hidden': !inline || !show }">
  <div ref="content" :id="cardId" class="n-tour-step-content-root" role="status" aria-live="polite">
    <div class="n-tour-step-card">
      <div class="n-tour-step-header">
        <p v-if="stepLabel" class="n-tour-step-step-label">{{ stepLabel }}</p>
        <div class="n-tour-step-controls">
          <button
            type="button"
            class="n-tour-step-control"
            :aria-label="dismissLabel"
            :title="dismissLabel"
            @click="$emit('dismiss')"
          >
            <n-icon icon="x" size="s" />
          </button>
        </div>
      </div>
      <p v-if="title" class="n-tour-step-title">{{ title }}</p>
      <p class="n-tour-step-description">{{ description }}</p>
    </div>
  </div>
</div>
